/**
 * O paciente como as LISTAS o mostram: a linha da tabela e o filtro que a produz.
 *
 * Fica em `domain` porque tem quatro donos: Colaboradores, Monitoramentos
 * Compartilhados, o detalhe (que recebe a linha ja em maos, para o cabecalho nao
 * piscar) e o Relatorio de Sono (que monta a lista de candidatos a partir dela).
 */
import { fromBackend } from './instant';
/**
 * A pagina como o painel a le: a hora de cada ultima medicao no fuso de quem olha.
 *
 * Colaboradores e Monitoramentos pedem a lista por endpoints diferentes, e a mesma forma
 * volta dos dois. O nascimento e DIA e nao passa por aqui.
 */
export function collaboratorPageFromBackend(page) {
    return {
        ...page,
        elements: (page.elements ?? []).map((patient) => ({
            ...patient,
            lastMeasurements: (patient.lastMeasurements ?? []).map((measurement) => ({
                ...measurement,
                date: fromBackend(measurement.date)
            }))
        }))
    };
}
//# sourceMappingURL=patient.js.map